import React from 'react';
import NavItem from './NavItem';

const navItems = [
    {
        name: 'General'
    },
    {
        name: 'Alerts Settings'
    },
    {
        name: 'Integrations'
    },
    {
        name: 'Plan'
    }
];

export default function NavBar({ active, handleMode }) {
    return (
        <div className="account-navbar">
            {navItems.map(item => (
                <NavItem
                    key={item.name}
                    active={active}
                    name={item.name}
                    handleMode={handleMode}
                />
            ))}
        </div>
    );
}
